import { useToast } from "@chakra-ui/toast";
import { DeleteOutline as DeleteOutlineIcon } from "@mui/icons-material";
import { FC, useCallback, useMemo } from "react";
import { graphql } from "react-relay";

import { PopupSetDetailLinkedPopupListTableActions_Mutation } from "~/src/__relay_artifacts__/PopupSetDetailLinkedPopupListTableActions_Mutation.graphql";
import { TableActions } from "~/src/components/common/tables/TableActions";
import { DeleteConfirmDialog } from "~/src/components/features/global/DeleteConfirmDialog";
import { useOpenState } from "~/src/lib/hooks";
import { useMutationCommit } from "~/src/lib/react-relay";

type Props = {
  popupName: string;
  popupSettingId: string;
  connectionId: string;
};

const mutation = graphql`
  mutation PopupSetDetailLinkedPopupListTableActions_Mutation(
    $connections: [ID!]!
    $input: DeletePopupSettingInput!
  ) {
    deletePopupSetting(input: $input) {
      deletedPopupSettingId @deleteEdge(connections: $connections)
    }
  }
`;

export const PopupSetDetailLinkedPopupListTableActions: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ popupName, popupSettingId, connectionId }) => {
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useOpenState();

  const mutate =
    useMutationCommit<PopupSetDetailLinkedPopupListTableActions_Mutation>(
      mutation
    );

  const handleDelete = useCallback(async () => {
    try {
      const res = await mutate({
        variables: {
          input: {
            popupSettingId,
          },
          connections: [connectionId],
        },
      });
      const deletedPopupSettingId =
        res.deletePopupSetting?.deletedPopupSettingId;
      if (!deletedPopupSettingId) throw new Error("assertion failed");

      toast({
        title: `${popupName}との紐付けを取り消しました`,
        status: "success",
      });
    } catch (err) {
      toast({ title: "取り消しに失敗しました", status: "error" });
    }
  }, [connectionId, mutate, popupName, popupSettingId, toast]);

  const menus = useMemo(
    () => [
      {
        label: "削除",
        icon: <DeleteOutlineIcon />,
        onClick: () => onOpen(),
      },
    ],
    [onOpen]
  );

  return (
    <>
      <TableActions actionMenus={menus} />
      <DeleteConfirmDialog
        name={popupName}
        isOpen={isOpen}
        onClose={onClose}
        onDelete={handleDelete}
      />
    </>
  );
};
